var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.63,
    height: 11.028,
    viewBox: "0 0 31.63 11.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#211c51",
    d: "M31.237 172.041c-.1-.021-10-2.129-14.619-5.21a.5.5 0 0 0-.565.011 9.067 9.067 0 0 0-2.509 3.318c-4.381-.752-8.57-1.645-11.585-2.478A1.549 1.549 0 0 0 0 169.178v5.989a2.611 2.611 0 0 0 2.608 2.608h16.9c7.452 0 11.707-2.606 11.884-2.717a.5.5 0 0 0 .233-.42v-2.113a.5.5 0 0 0-.388-.484zm-14.854-4.183a41.693 41.693 0 0 0 9.892 3.954c-2.918-.229-6.3-.635-9.937-1.2q-.888-.137-1.775-.284a8.823 8.823 0 0 1 1.82-2.47zm3.13 8.927H2.608A1.62 1.62 0 0 1 1 175.36a2.069 2.069 0 0 0 1.079.3h13.736a13.825 13.825 0 0 1 2.4.36 31.011 31.011 0 0 0 4.153.624c-.889.089-1.842.141-2.855.141zm11.127-2.476a19.549 19.549 0 0 1-12.227.742 14.343 14.343 0 0 0-2.6-.379H2.081a1.092 1.092 0 0 1-1.091-1.09v-4.4a.559.559 0 0 1 .222-.449.549.549 0 0 1 .483-.093c7.349 2.032 20.873 4.291 28.944 4.382z",
    transform: "translate(0) translate(0 0) translate(0 -166.747)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoes);
export default __webpack_public_path__ + "static/media/shoes.91b3aa7c.svg";
export { ForwardRef as ReactComponent };